export const cloverColorTheme = {
  grayNeutral: "#5D5D5D",
  Main: {
    primaryColor: "#228800",
    secondaryColor: "#226600",
  },
};
